export const bim = {
  addBim: "Add BIM",
  progressHelp:
    "Files must be processed in order to view, this process may take a few minutes.",
};
